import { IDataTableColumn, useGridState } from "nsitools-react";
import * as React from "react";

import { HealthTestRequestCharacteristicGridDto } from "../../../../api";
import { useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { CustomDataTable } from "../../../../components";

export interface IHealthCharacteristicListProps {
  data: HealthTestRequestCharacteristicGridDto[];
}

export const HealthCharacteristicList: React.FunctionComponent<IHealthCharacteristicListProps> = ({ data }) => {
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: false,
    enablePagination: true,
    enableFilter: false,
    availablePageSizes: [50],
    pageSize: 50,
    data: data,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Characteristic),
        fieldName: "characteristic",
        render: (row: HealthTestRequestCharacteristicGridDto) =>
          `[${row.characteristicCode}] ${row.characteristicName}`,
      },
    ],
    [t]
  );

  return <CustomDataTable tableState={tableState} columns={columns} renderNoData={<></>} />;
};
